import CourseList from '../components/CourseList';

export default function StepSelectCourse({
  loading,
  courses,
  selectedCourse,
  onSelect,
}) {
  return (
    <div>
      <h4>Select a Course</h4>
      <CourseList
        loading={loading}
        courses={courses}
        selectedCourse={selectedCourse}
        onSelect={onSelect}
      />
    </div>
  );
}
